__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/04c30e2/_next/";